var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20084 17.8047C9.46863 18.0651 9.9028 18.0651 10.1706 17.8047L15.6563 12.4714C15.7849 12.3464 15.8571 12.1768 15.8571 12C15.8571 11.8232 15.7849 11.6536 15.6563 11.5286L10.1706 6.19526C9.9028 5.93491 9.46863 5.93491 9.20084 6.19526C8.93305 6.45561 8.93305 6.87772 9.20084 7.13807L14.2017 12L9.20084 16.8619C8.93305 17.1223 8.93305 17.5444 9.20084 17.8047Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.64ff3a71b43b286cfcc2392bb477add7.svg";
export { ForwardRef as ReactComponent };